import {
  Button,
  Group,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { useProfileStore } from "../../../stores/UserStore";
import GetStarted from "./GetStarted";
import { useUIStore } from "../../../stores/UIStore";
import { useEffect } from "react";
import HomeReporting from "./HomeReporting";
import { useLanguage } from "../../../stores/LanguageStore";
import { Link } from "react-router-dom";
import { getPermission } from "../../../functions/utilFunctions";
import IconSubscription from "../../../assets/icons/IconSubscription";
import NewUserModal from "./NewUserModal";
import { daysUntil } from "../../../functions/dates";
import PaymentError from "../settings/subscription/PaymentError";

const Home = () => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);

  useEffect(() => {
    useUIStore.getState().setHeaderClosed(false);
  }, []);

  return (
    <Stack flex={1} px={64} pb={16}>
      <Group justify="space-between" mt={32} wrap="nowrap" mb={8}>
        <Stack ml={"auto"} mr={"auto"} gap={8}>
          <Title order={2} ff={"Inter"} ta={"center"}>
            {lang.home.hello} {useProfileStore.getState()?.profile?.first_name}{" "}
            <span style={{ fontSize: 24 }}>👋</span>
          </Title>

          {profile?.subscriptions?.trial && (
            <Text size="md" c={"red"} fw={600} ta={"center"} ml={-6}>
              {daysUntil(profile?.subscriptions?.end_date)}
            </Text>
          )}
        </Stack>

        {!profile?.subscriptions?.trial &&
          !profile?.subscriptions?.active &&
          !profile?.subscriptions?.subscription_id && (
            <Text
              size="md"
              c={"red"}
              fw={600}
              ta={"center"}
              pos={"absolute"}
              right={272}
            >
              {lang.pricing.free.ended_short}
            </Text>
          )}

        <PaymentError />

        {!profile?.subscriptions?.subscription_id &&
          getPermission("displayPricing") && (
            <Button
              size="lg"
              radius={"md"}
              leftSection={
                <ThemeIcon variant="subtle">
                  <IconSubscription fill="#fcfbff" />
                </ThemeIcon>
              }
              w={180}
              fz={18}
              pos={"absolute"}
              right={64}
              component={Link}
              to={"/settings/subscription/account"}
            >
              {lang.home.subscribe}
            </Button>
          )}
      </Group>

      <HomeReporting />

      {/* <ReportingSummary /> */}

      <Group wrap="nowrap" align="start" gap={"xl"}>
        <GetStarted />
      </Group>

      {/* <NewUiOnboarding /> */}

      <NewUserModal />
    </Stack>
  );
};

export default Home;
